"use client";

import React from "react";
import { BrickWall, House, Building2, Hammer, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Rohbauarbeiten",
  description: "Präzise Ausführung von Rohbauten für solide und langlebige Grundstrukturen.",
  icon: BrickWall
}, {
  title: "Wohnungsbau",
  description: "Realisierung von Ein- und Mehrfamilienhäusern.",
  icon: House
}, {
  title: "Gewerbebau",
  description: "Robuste Bauweise für Bürogebäude und Hallen.\n",
  icon: Building2
}];
export default function Leistungen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="leistungen" ref={ref} className="bg-background relative overflow-hidden ![padding:96px_0px_0px_0px]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-6 font-sans">
            Unsere Leistungen
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto font-sans">Als Spezialist für Rohbauarbeiten bieten wir Ihnen maßgeschneiderte Lösungen für Wohn- und Gewerbeprojekte.&nbsp;</p>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-16">
          {services.map((service, index) => <div key={index} data-index={index} className={`h-full transition-all duration-700 ease-out`} style={{
          transitionDelay: `${index * 100}ms`,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(2rem)'
        }}>
              <Card className="h-full border border-border bg-card/50 hover:bg-card transition-all duration-300 rounded-[2px] shadow-[inset_0_0_20px_rgba(0,0,0,0.02)] hover:shadow-[inset_0_0_30px_rgba(0,0,0,0.04)] group hover:-translate-y-1">
                <CardHeader className="pb-2">
                  <div className="w-12 h-12 rounded-[2px] bg-secondary/5 flex items-center justify-center mb-4 group-hover:bg-primary/10 transition-colors duration-300 border border-border/50">
                    <service.icon className="w-6 h-6 text-foreground group-hover:text-primary transition-colors duration-300" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground font-sans">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-muted-foreground text-base leading-relaxed font-sans">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>

        {}
        <div className={`text-center transition-all duration-700 ease-out delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        </div>
      </div>
    </section>;
}